import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faKeyboard } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';

interface KeyboardShortcutTooltipProps {
    show: boolean;
    keyName: string;
}

export const KeyboardShortcutTooltip = ({ show, keyName }: KeyboardShortcutTooltipProps) => {
    if (show) {
        return (
            <span className="badge badge-info">
                <FontAwesomeIcon icon={faKeyboard as IconProp} />
                &nbsp;{keyName}
            </span>
        );
    } else {
        return null;
    }
}
